import { combineLatest } from 'rxjs';
const defaultConfig = {
    requestUpdate: true,
};
class SubscribeReactiveController {
    constructor(host, observers, config) {
        this.host = host;
        this.observers = observers;
        host.addController(this);
        this.config = { ...defaultConfig, ...config };
        this.subscribe();
    }
    hostDisconnected() {
        this.subscription?.unsubscribe();
    }
    subscribe() {
        const observable = combineLatest(Array.isArray(this.observers) ? this.observers : [this.observers]);
        this.subscription = observable.subscribe(() => {
            if (!this.config.requestUpdate)
                return;
            this.host.requestUpdate();
        });
    }
}
export function subscribe(host, observers, config) {
    return new SubscribeReactiveController(host, observers, config);
}
//# sourceMappingURL=subscribe-reactive-controller.js.map